import { render, staticRenderFns } from "./table-partner.vue?vue&type=template&id=08e37cdc&scoped=true"
import script from "./table-partner.vue?vue&type=script&lang=js"
export * from "./table-partner.vue?vue&type=script&lang=js"
import style0 from "./table-partner.vue?vue&type=style&index=0&id=08e37cdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e37cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e37cdc')) {
      api.createRecord('08e37cdc', component.options)
    } else {
      api.reload('08e37cdc', component.options)
    }
    module.hot.accept("./table-partner.vue?vue&type=template&id=08e37cdc&scoped=true", function () {
      api.rerender('08e37cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/partner/table-partner.vue"
export default component.exports